import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notificationListing: {
    loading: false,
    error: null,
    data: null,
  },
  unreadCount: {
    loading: false,
    error: null,
    data: 0,
  },
  markAsRead: {
    loading: false,
    error: null,
    data: null,
  },
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    // Notification Listing
    notificationListingStart: (state) => {
      state.notificationListing.loading = true;
      state.notificationListing.error = null;
    },
    notificationListingSuccess: (state, action) => {
      state.notificationListing.loading = false;
      state.notificationListing.data = action.payload;
      state.notificationListing.error = null;
    },
    notificationListingFailure: (state, action) => {
      state.notificationListing.loading = false;
      state.notificationListing.error = action.payload;
    },
    notificationListingReset: (state) => {
      state.notificationListing = initialState.notificationListing;
    },

    // Unread Count
    unreadCountStart: (state) => {
      state.unreadCount.loading = true;
      state.unreadCount.error = null;
    },
    unreadCountSuccess: (state, action) => {
      state.unreadCount.loading = false;
      state.unreadCount.data = action.payload;
      state.unreadCount.error = null;
    },
    unreadCountFailure: (state, action) => {
      state.unreadCount.loading = false;
      state.unreadCount.error = action.payload;
    },

    // Mark as Read
    markAsReadStart: (state) => {
      state.markAsRead.loading = true;
      state.markAsRead.error = null;
      state.markAsRead.data = null;
    },
    markAsReadSuccess: (state, action) => {
      state.markAsRead.loading = false;
      state.markAsRead.data = action.payload;
      state.markAsRead.error = null;
    },
    markAsReadFailure: (state, action) => {
      state.markAsRead.loading = false;
      state.markAsRead.error = action.payload;
    },
    markAsReadReset: (state) => {
      state.markAsRead = initialState.markAsRead;
    },

    // Decrement unread count (local update after marking as read)
    decrementUnreadCount: (state) => {
      if (state.unreadCount.data > 0) {
        state.unreadCount.data -= 1;
      }
    },

    // Reset unread count (after marking all as read)
    resetUnreadCount: (state) => {
      state.unreadCount.data = 0;
    },
  },
});

export const {
  notificationListingStart,
  notificationListingSuccess,
  notificationListingFailure,
  notificationListingReset,
  unreadCountStart,
  unreadCountSuccess,
  unreadCountFailure,
  markAsReadStart,
  markAsReadSuccess,
  markAsReadFailure,
  markAsReadReset,
  decrementUnreadCount,
  resetUnreadCount,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
